import { UAParser } from 'ua-parser-js';

export function getUseragent() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const parser = new UAParser(userAgent);
  const parseredUseragent = parser.getResult();
  return parseredUseragent;
}
